/** @jsxImportSource @emotion/react */
import { css, Global } from '@emotion/react';
import { theme } from '@terveystalo/design-system-theme';
import React, { useEffect } from 'react';
import { PageWrapper } from 'ui/common/PageWrapper';
import { useAuthContext } from 'utils/auth/auth-context';
import { allowedOrigins } from 'utils/communication/config';
import { sendMessage } from 'utils/communication/useSendMessages';
import { EmbedInitializeAuth } from 'utils/types/communication';

function App() {
  const { handleParentAuth } = useAuthContext();
  // eslint-disable-next-line
  const parseJsonObject = <T,>(value: object | string | undefined): T => {
    if (value && typeof value === 'string') {
      return JSON.parse(value) as T;
    }
    return value as unknown as T;
  };

  /* 
    Handle init only once. Embedded mobile app does not use postMessage.
  */
  useEffect(() => {
    if (window.terveystaloApp) {
      const { auth, authorization } = window.terveystaloApp;

      const accessToken = authorization
        ? parseJsonObject<EmbedInitializeAuth>(authorization)?.token?.idToken // OW
        : parseJsonObject<EmbedInitializeAuth>(auth)?.token?.accessToken; // Auth0

      if (!accessToken) {
        return; // TODO test if return necessary
      }
      handleParentAuth(accessToken);
    }
    window.addEventListener(
      'message',
      event => {
        if (!allowedOrigins.includes(event.origin)) {
          sendMessage({
            type: 'Error',
            payload: { type: 'DisallowedOrigin', message: `Origin ${event.origin} not allowed` },
          });
          return;
        }
        switch (event.data.type) {
          case 'Auth':
            handleParentAuth(event.data.payload.accessToken, event.data.payload.age, event.data.payload.gender);
            break;
          default:
            break;
        }
      },
      false,
    );
    sendMessage({ type: 'Init' });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <Global
        styles={css`
          body {
            background: ${theme.color.zodiacBlack04};
            position: relative;
          }
        `}
      />
      <PageWrapper />
    </div>
  );
}

export default App;
